/**
 * FASE 21.8 — AUDIT TRAIL
 *
 * In-memory audit log for Kevia mutation events.
 * Session-scoped — not persisted (future: Supabase audit_logs table).
 *
 * Never stores user content (notes text, prayer content, etc.).
 * Only structural metadata: what happened, to whom, by which role.
 */

const MAX_ENTRIES = 50;

/** @type {Array<{id, toolId, role, timestamp, entityType, entityId?, success, latency, source, error?}>} */
const _log = [];

let _seq = 0;

/**
 * @param {Object} entry
 * @param {string} entry.toolId
 * @param {string} entry.role
 * @param {string} entry.entityType
 * @param {string} [entry.entityId]
 * @param {boolean} entry.success
 * @param {number} entry.latency
 * @param {string} [entry.error]
 */
export function logMutationEvent({ toolId, role, entityType, entityId, success, latency, error }) {
  if (_log.length >= MAX_ENTRIES) _log.shift();
  _log.push({
    id:         `audit_${++_seq}`,
    toolId,
    role:       role ?? "*",
    timestamp:  Date.now(),
    entityType,
    entityId:   entityId ?? null,
    success,
    latency,
    source:     "kevia",
    error:      error ?? null,
  });
}

/** Returns a snapshot of the audit trail (most recent first). */
export function getAuditTrail() {
  return [..._log].reverse();
}

/** Returns the most recent mutation event. */
export function getLastMutation() {
  return _log[_log.length - 1] ?? null;
}

export function clearAuditTrail() {
  _log.length = 0;
}
